(function($, undefined) {
	
	'use strict';
    var win;
	var sideNavSubMenuBtn;
    var sideNavCtn;
    var sideNavCtnHeight;
    var sideNavOuterCtn;
    var sideNavOuterCtnTop;
    var sideNavOuterCtnHeight;

    var checkScroll = function() {
        sideNavCtnHeight = sideNavCtn.height();
        sideNavOuterCtnTop = sideNavOuterCtn.offset().top - 60;
        sideNavOuterCtnHeight = sideNavOuterCtn.height();
        var maxBottom = ((sideNavOuterCtnHeight + sideNavOuterCtnTop - 70) - sideNavCtnHeight);
        var top = 0;

        if (win.scrollTop() > maxBottom) {
            top = sideNavOuterCtnHeight - sideNavCtnHeight - 70;
        } else if (win.scrollTop() > sideNavOuterCtnTop) {
            top = win.scrollTop() - sideNavOuterCtnTop;
        } else if (win.scrollTop() <= sideNavOuterCtnTop) {
            top = 0;
        }

        $('.side-nav-inner-ctn.absolute').css('top', top + 'px');
    };

	var toggleSideSubNav = function() {
		var t = $(this);
        var id = t.closest('.side-nav-item-link-outer-ctn').attr('data-id');
		var ctn = $('.side-nav-item-link-outer-ctn[data-id=' + id + ']');

		ctn.toggleClass('open');
        if (ctn.hasClass('open')) {
    		$('.side-nav-inner-ctn.invisible').find(ctn).find('.side-nav-sub-ctn').slideDown(function() {
                checkScroll();
                $('.side-nav-inner-ctn.absolute').find(ctn).find('.side-nav-sub-ctn').slideDown();
            });
        } else {
            ctn.find('.side-nav-sub-ctn').slideUp(function() {
                checkScroll();
            });
        }
	};
	
	var init = function () {
        win = $(window);
		sideNavSubMenuBtn = $('.side-nav-item-link-ctn .sub-nav-arrow');
        sideNavCtn = $('.side-nav-inner-ctn.invisible');
        sideNavOuterCtn = $('.side-nav-wrap-ctn');

        if ($('.side-nav').length) {        
            checkScroll();

            win.scroll(function() {
                checkScroll();
            });
            win.resize(function() {
                checkScroll();
            });
        }

		sideNavSubMenuBtn.click(toggleSideSubNav);
	};
	
	$(init);
	
})(jQuery);
